import "./css/main.css";
import "./js/components/a11y";
import "./js/components/accordion";
import "./js/components/swiper";
import "./js/components/dialog";
import "./js/components/drawer";
import "./js/components/modal";
import "liquid-ajax-cart";
import "./js/components/facets";
import "./js/components/ajaxinate";
import "./js/snippets/product-card";
import "./js/snippets/localization-form";
import "./js/components/search";
import "./js/components/selling-plan";
import "./js/components/quick-order";
import "./js/templates/cart";
import "./js/templates/header";

// Templates
import LoadSections from "./js/sections";

// Initialisation code
(() => {
  const Moonbase = window.Moonbase || {};
  console.log("🚀 Shopify Theme by Brave The Skies");
  document.documentElement.className =
  document.documentElement.className.replace("no-js", "js");

  // Listen for the "liquid-ajax-cart:request-end" event which is fired
  // after a Shopify Cart API Ajax request is performed
  document.addEventListener("liquid-ajax-cart:request-end", (event) => {
    const { requestState } = event.detail;

    // If the "add to cart" request is successful
    if (requestState.requestType === "add" && requestState.responseData?.ok) {
      document.body.classList.add("overlay--active");
    }
  });
  window.Moonbase.setRecentlyViewedProducts = (productData) => {
    const productList = [];
    let jsonResp, jsonRespArr, jsonRespArrStr;
    productList.push(productData);
    const currProductPageTitle = productData.title;
    const productDataString = JSON.stringify(productList);
    const localData = localStorage.getItem("recentlyViewedProducts");
    if (localData === null) {
      localStorage.setItem("recentlyViewedProducts", productDataString);
    } else if (localData) {
      const oldProductData = localStorage.getItem("recentlyViewedProducts");
      const parsedOldProductData = JSON.parse(oldProductData);
      const sameProduct = oldProductData.includes(currProductPageTitle);
      if (sameProduct) {
        const index = parsedOldProductData.findIndex(
          (product) => product.title === currProductPageTitle
        );
        if (index !== -1) {
          parsedOldProductData[index] = productData;
          localStorage.setItem(
            "recentlyViewedProducts",
            JSON.stringify(parsedOldProductData)
          );
        }
      } else {
        jsonRespArr = parsedOldProductData.concat(productList);
        localStorage.setItem(
          "recentlyViewedProducts",
          JSON.stringify(jsonRespArr)
        );
      }
    }
  };

  // Overlay
  const closeOverlayButtons = document.querySelectorAll(
    "[close-overlay-button]"
  );
  const closeOverlay = () => {
    document.body.classList.remove(Moonbase.classes.minicartOpen);
  };

  closeOverlayButtons.forEach((button) => {
    button.addEventListener("click", closeOverlay);
  });

  const overlay = document.querySelector(".site-overlay");
  overlay.addEventListener("click", () => {
    document.body.classList.remove(Moonbase.classes.filterDrawerOpen);
  });

  /* Initialise a global Moonbase variable
	 that can be accessed on the front end
	 if not already defined. */

  // used to dynamically load template & section js per page.
  // prevents loading js that isn't required
  // Add sections in theme-js.liquid:
  // Moonbase.sections = [
  //      ...
  //     'my-new-section'
  // ]
  LoadSections(Moonbase.sections)
    .then(() => {
      Moonbase.loaded = true;
      const evt = new CustomEvent("moonbase:loaded");
      console.log("Moonbase loaded");
      document.dispatchEvent(evt);
    })
    .catch((e) => console.log("Error loading template files", e));
})();
